module.exports = __webpack_public_path__ + "static/media/quid-live-2020.37317810.svg";